import  { useEffect, useRef } from "react";
import styled from "styled-components";

const WaveVisualizer = ({ status = "recording" }) => {
  const canvasRef = useRef(null);
  const currentAmplitudeRef = useRef(0);
  const frameRef = useRef(0);

  // amplitude: 항상 일정, speed: recording일 때만 움직임
  const amplitude = 20;
  const speed = status === "recording" ? 1 : 0;
  const wavelength = 75;

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
    const width = canvas.width;
    const height = canvas.height;

    const waves = [
      { color: "rgba(53,204,83,0.45)", offset: 0 },
      { color: "rgba(53,204,83,0.2)", offset: 60 },
      { color: "rgba(53,204,83,0.1)", offset: 120 },
    ];

    let animationId;

    const draw = () => {
      ctx.clearRect(0, 0, width, height);

      // amplitude 자연스럽게 lerp (큰 변화가 없으면 거의 일정)
      const current = currentAmplitudeRef.current;
      const lerped = current + (amplitude - current) * 0.05;
      currentAmplitudeRef.current = lerped;

      waves.forEach((wave) => {
        ctx.beginPath();
        for (let x = 0; x <= width; x++) {
          const y =
            height / 2 +
            Math.sin((x + frameRef.current + wave.offset) / wavelength) * lerped +
            Math.sin((x + frameRef.current * 0.5 + wave.offset) / (wavelength * 1.8)) *
              lerped *
              0.5;
          ctx.lineTo(x, y);
        }
        ctx.strokeStyle = wave.color;
        ctx.lineWidth = 2;
        ctx.stroke();
      });

      // recording일 때만 frame 증가 -> 구불구불 움직임
      if (speed > 0) frameRef.current += speed;

      animationId = requestAnimationFrame(draw);
    };

    draw();
    return () => cancelAnimationFrame(animationId);
  }, [status]); // status가 바뀌면 draw 다시 실행

  return <Canvas ref={canvasRef} />;
};

const Canvas = styled.canvas`
  width: 100%;
  height: 120px;
  display: block;
`;

export default WaveVisualizer;
